import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import About from './components/About';
import Craftsmanship from './components/Craftsmanship';
import Menu from './components/Menu';
import Story from './components/Story';
import WhyUken from './components/WhyUken';
import Experience from './components/Experience';
import ShopInfo from './components/ShopInfo';
import Reviews from './components/Reviews';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Reason from './components/Reason';

export default function HomePage() {
  return (
    <main className="font-rounded min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Craftsmanship />
      <Menu />
      <Story />
      <WhyUken />
      <Experience />
      <ShopInfo />
      <Reviews />
      <Gallery />
      <Contact />
      <Reason />
      <Footer />
    </main>
  );
}
